export default __webpack_public_path__ + "static/media/IMG_20190601_192053.3f6711ae.jpg";